import React from 'react'
import { ToastContainer } from 'react-toastify'

const CustomToast = ({theme,position,closeTime}) => {
  return (
    <ToastContainer autoClose={1500}/>
  )
}

export default CustomToast